<template>
  <div>
    <!-- :get-form-data="fromData" -->

    <list
      row-key="Id"
      ref="list"
      unit="当前排产任务"
      :page="true"
      :show-query="true"
      :get-data-func="workDocApi.currplantasklist"
      
      :temp-params="tempParams"
      urlHash="production/scheduling/currschedulingtask/notScheduling"
    >
      <template slot="toolbar-right">
        <el-button type="success" @click="onExport">导出</el-button>
      </template>
      <!-- <el-table slot="subTable" @selection-change="handleSelectionChange" class="tb-c-head" :data="tableData" border style="margin-bottom: 18px" max-height="500">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="生产部门" prop="DpName" min-width="170" show-overflow-tooltip />
        <el-table-column label="生产班组" prop="Team" min-width="170" show-overflow-tooltip />
        <el-table-column label="生产班次" prop="Schedule" min-width="120" show-overflow-tooltip />
        <el-table-column label="设备名称" prop="MaintenanceName" min-width="120" />
        <el-table-column label="布产时间" prop="SchedulingDate" min-width="70" />
        <el-table-column label="计划开始时间" prop="StartTime" width="80" />
        <el-table-column label="计划完成时间" prop="EndTime" width="90" />
        <el-table-column label="排产任务数量" prop="Quantity" width="100" />
        <el-table-column label="已生产数量" prop="ThisReportQuantity" width="100" />
        <el-table-column label="未生产数量" prop="LeftoverQuantity" width="100" />
      </el-table> -->
      <!-- <template slot="tabs">
        <el-tabs v-model="tabName" type="card" @tab-click="tabClick">
          <el-tab-pane v-for="(item, index) in machiningStageList" :key="index" :label="item.Name + '工单' + '(' + item.Len + ')'" :name="item.MachiningStageId + ''"></el-tab-pane>
        </el-tabs>
      </template> -->
      <!-- <template slot="table">
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row, $index }">
            <el-button v-if="$permission.canWrite()" type="text" @click="edit(row, $index)">编辑</el-button>
            <el-button v-if="$permission.canWrite()" type="text" @click="drain(row)">排入</el-button>
          </template>
        </el-table-column>
      </template> -->
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <!-- <team-dialog ref="teamDialog" @change="changeTeam"></team-dialog>
    <drain-dialog ref="drainDialog" @changeDrain="changeDrain"></drain-dialog>
    <schedule-dialog ref="scheduleDialog" @change="changePlanDts"></schedule-dialog> -->
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'

// import tableColumn from '@/data/production/scheduling/teamscheduling/notScheduling/list.json'
// import tableParam from '@/data/production/scheduling/teamscheduling/notScheduling/query.json'

// import teamDialog from './teamDialog'
// import scheduleDialog from './scheduleDialog'
// import drainDialog from './drainDialog'

export default {
  mixins: [listMixin],
  components: { list, 
    // teamDialog, drainDialog, scheduleDialog 
  },
  props: {
    dpid: {
      type: Number,
      default: null
    },
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      clothProductionApi: require('@/api/production/clothProduction').default,
      api: require('@/api/pu/plan').default,
      workDocApi: require('@/api/production/workDoc').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      params: {
        Order: '',
        SubOrder: '',
        CustomerName: '',
        DocTime: '',
        StockName: '',
        Remark: '',
        Department: '',
        Salesman: ''
      },
      tableData: [],
      result: {},
      index: 0,
      _dpid: null,
      tabName: '0',
      tempParams: {
        isFinish: true,
        // SchedulingType: 0,
        // IsScheduling: false,
        // ProductionDpId: null,
        // OrderProductIds: []
      },
      OrderProductIds: [],
      Combination: [],
      Assembling: [],
      Parts: [],
      Special: [],
      Injection: [],
      wid: 0,
      aleayCombination: [],
      aleayAssembling: [],
      aleayParts: [],
      aleaySpecial: [],
      aleayInjection: [],
      machiningStageList: []
    }
  },
  watch: {
    dpid(val) {
      this.tempParams.ProductionDpId = val
      this.subTableEnter()
    },
    machiningStageList: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal, 'aa watch')
      },
      deep: true
    }
  },
  created() {
    console.log(this.tempParams.isFinish, 'isFinish');
    // this.clothProductionApi
    //   .list({
    //     IsUnScheduled: true,
    //     SchedulingType: 0
    //   })
    //   .then(res => {
    //     console.log('res', res)
    //     if (res.Code === 0) {
    //       res.Data.forEach(item => {
    //         item.OrderDate = this.toDateString(item.OrderDate)
    //       })
    //       this.tableData = res.Data
    //     }
    //   })
    // this.machiningStageApi.list({ Status: 1 }).then(res => {
    //   this.machiningStageList = res.Data
    //   this.machiningStageList.forEach(x => {
    //     if (x.MachiningStageId == 1) {
    //       x.MachiningStageId = 0
    //     }
    //     x.Len = 0
    //     x.datas = []
    //   })
    // })
  },

  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map((x) => x.tableName);
          var params = { ...listParams, ...this.tempParams, Fields: fields.join(",") };
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.workDocApi.currplantasklistexport(params).then(() => {
            loading.close();
          });
        })
        .catch(() => {});
    },
    // setAleayData(data) {
    //   let { Combination, Assembling, Parts, Special, Injection } = data

    //   this.aleayCombination = Combination
    //   this.aleayAssembling = Assembling
    //   this.aleayParts = Parts
    //   this.aleaySpecial = Special
    //   this.aleayInjection = Injection
    // },
    // changeDrain() {
    //   this.subTableEnter()
    // },
    // changeTeam() {
    //   this.subTableEnter()
    // },
    // changePlanDts(data) {
    //   console.log(data, 'aa')
    //   //this.subTableEnter()
    //   var stage = this.machiningStageList.find(x => x.MachiningStageId == Number(this.tabName))
    //   if (stage) {
    //     var datas = stage.datas
    //     var row = datas[data.index]
    //     row.Schedule = data.Schedule
    //     row.MaintenanceName = data.Maintenance
    //     row.Team = data.Team;
    //     row.PlanDts=data.PlanDts;
    //     this.$refs.list.setTable(datas)
    //   }
    // },
    // toDateStringByFormat(value, format) {
    //   if (!value) return ''
    //   let m = this.$moment(value)
    //   if (!m.isValid()) {
    //     return ''
    //   }
    //   return m.format(format)
    // },
    // //返回YYYY-MM-DD格式的字符串
    // toDateString(value) {
    //   return this.toDateStringByFormat(value, 'YYYY-MM-DD')
    // },
    // handleSelectionChange(rows) {
    //   this.OrderProductIds = rows.map(item => {
    //     return item.OrderProductId
    //   })

    //   this.tempParams.OrderProductIds = this.OrderProductIds
    // },
    // addIndex(arr) {
    //   arr.forEach((item, i) => {
    //     item.indexNumber = i + 1
    //   })

    //   return arr
    // },
    // setInjection(data) {
    //   data.forEach(item => {
    //     item.ProductName = item.MouldName
    //     item.ProductNo = item.MouldNo
    //   })

    //   return data
    // },
    // resetDataFunc(resData) {
    //   // let Combination = []
    //   // let Assembling = []
    //   // let Parts = []
    //   // let Special = []
    //   // let Injection = []

    //   // let data = resData
    //   // console.log(data, 'restData')
    //   // let length = data.length

    //   // let dps = data.map(item => {
    //   //   return item.DpName
    //   // })

    //   // dps = Array.from(new Set(dps))

    //   // dps = dps.filter(item => {
    //   //   return item != null
    //   // })

    //   // let arr = []
    //   // dps.forEach(item => {
    //   //   let arr1 = data.filter(v => {
    //   //     return item === v.DpName
    //   //   })
    //   //   let o = {
    //   //     dps: arr1
    //   //   }
    //   //   arr.push(o)
    //   // })

    //   // let dpSelect = []
    //   // arr.forEach(item => {
    //   //   let o = {
    //   //     ProductionDpId: item.dps[0]?.ProductionDpId,
    //   //     ProductionDpName: item.dps[0]?.DpName,
    //   //     ProductionDpNumber: item.dps.length
    //   //   }
    //   //   dpSelect.push(o)
    //   // })
    //   // console.log(dpSelect, 'dpSelect')
    //   // this.$emit('getDp', dpSelect)

      
    //   // this.machiningStageList.forEach((x, index) => {
    //   //   console.log(x, x.MachiningStageId, 'ss')
    //   //   var list = data.filter(w => w.Stage == x.MachiningStageId)
    //   //   console.log(list, data, 'list')
    //   //   if (x.MachiningStageId == 0) {
    //   //     list = this.setInjection(list)
    //   //   }
    //   //   x.datas = this.addIndex(list)
    //   //   x.Len = x.datas.length

    //   //   this.$set(this.machiningStageList, index, x)
    //   // })

    //   // var stage = this.machiningStageList.find(x => x.MachiningStageId == Number(this.tabName))
    //   // if (stage) this.$refs.list.setTable(stage.datas)

      
    //   // this.$emit('listEnd', { OrderProductIds: this.OrderProductIds })
    // },
    // subTableEnter() {
    //   // this.$refs.list.getData()
    //   // var data = this.$refs.list.data
    //   // console.log(data, 'sutableenter')
    //   // this.machiningStageList.forEach((x,index) => {
    //   //   var list = data.filter(w => w.Stage == x.MachiningStageId)
    //   //   if (list) {
    //   //     if (x.MachiningStageId == 0) {
    //   //       list = this.setInjection(list)
    //   //     }
    //   //     x.datas = this.addIndex(list)
    //   //     x.Len = x.datas.length
    //   //   } else {
    //   //     x.datas = []
    //   //     x.Len = 0
    //   //   }
    //   //   this.$set(this.machiningStageList, index, x)
    //   // })
    //   // var stage = this.machiningStageList.find(x => x.MachiningStageId == this.tabName)
    //   // if (stage) this.$refs.list.setTable(stage.datas)
      
    // },
    
    // tabClick() {
    //   console.log('tab', this.tabName)
    //   var stage = this.machiningStageList.find(x => x.MachiningStageId == Number(this.tabName))
    //   console.log(stage, this.machiningStageList, 'aa')
    //   if (stage) this.$refs.list.setTable(stage.datas)
    // },

    // edit(row, index) {
    //   console.log(row,"editrow")
    //   let { WorkDocId, TeamId, Team, ScheduleId, Schedule, PlanDts, Quantity,Stage } = row
    //   let arr = []
    //   arr.push(WorkDocId)
    //   let o = {
    //     WorkDocIds: arr,
    //     TeamId,
    //     Team,
    //     ScheduleId,
    //     Schedule,
    //     PlanDts,
    //     Quantity,
    //     index,
    //     Stage
    //   }

    //   this.$refs.scheduleDialog.openEdit(o)
    // },
    // drain(row) {
    //   this.$refs.drainDialog.openEdit(row).then(that => {
    //     let arr = []
    //     var stage = this.machiningStageList.find(x => x.MachiningStageId == this.tabName)
    //     if (stage) arr = stage.datas

    //     arr = arr.filter(item => {
    //       return item.Status === 0
    //     })
    //     let workDocs = []
    //     arr.forEach(item => {
    //       let o = {
    //         WorkDocNo: item.WorkDocNo,
    //         WorkDocId: item.WorkDocId
    //       }
    //       workDocs.push(o)
    //     })

    //     that.workDocs = workDocs
    //     that.data.WorkDocNo = ''
    //   })
    // }
  }
}
</script>
